import React, { FC } from 'react';

import { Popover, PopoverPosition } from '@mui/material';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';

// hooks
import useCMSPlaceholderQuery from '../../../../hooks/cms-placeholders/useCMSPlaceholderQuery';

interface CMSPlaceholderDropdownProps {
    anchorPosition: PopoverPosition;
    handleClick: (id: string) => void;
    onClose?: () => void;
}

const CMSPlaceholderDropdown: FC<
    React.PropsWithChildren<CMSPlaceholderDropdownProps>
> = ({ anchorPosition, handleClick, onClose }) => {
    const { data } = useCMSPlaceholderQuery();
    return (
        <Popover
            open
            anchorReference="anchorPosition"
            anchorPosition={anchorPosition}
            onClose={onClose}
        >
            <Container>
                {(data?.messageable ?? []).length > 0 ? (
                    <ListContainer>
                        {data?.messageable?.map((item) => (
                            <ListItem
                                key={item.id}
                                onClick={() => handleClick(item.id)}
                            >
                                {item.name}
                            </ListItem>
                        ))}
                    </ListContainer>
                ) : (
                    'Abandoned Cart data is not configured for your account. Contact your Aampe POC to set this up.'
                )}
            </Container>
        </Popover>
    );
};

const Container = styled.div(() => ({
    padding: aampeTheme.spacing(1),
}));

const ListContainer = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(1),
    maxHeight: '300px',
    overflow: 'auto',
}));

const ListItem = styled.span(() => ({
    cursor: 'pointer',
    padding: aampeTheme.spacing(1),
    color: aampeTheme.colors.gray800,

    '&:hover': {
        backgroundColor: aampeTheme.colors.bordersWG01,
        color: aampeTheme.colors.solidA01,
    },
}));

export default CMSPlaceholderDropdown;
